import { Dispatch, SetStateAction } from 'react';
import clsx from 'clsx';
import { Button } from 'antd';

import { IconArrowShewron } from '../Icon';
import AnimatedHeight from '../AnimatedHeight';
import CommentsList from '../Comments/CommentsList';
import { Comment } from '../../../store/comment';

import styles from './index.module.scss';

interface RepliesProps {
  isOpen: boolean;
  ownerId?: string;
  onOpenChange: (isOpen: boolean) => void;
  numberOfCommentsTotal: number;
  parentId?: string;
  onRepplyDeleted?: () => void;
  loading: boolean;
  onLoadMore: () => void;
  hasNextPage: boolean;
  comments: Comment[];
  setComments: Dispatch<SetStateAction<Comment[]>>;
}

function Replies({
  isOpen,
  ownerId,
  onOpenChange,
  numberOfCommentsTotal,
  parentId,
  onRepplyDeleted,
  loading,
  onLoadMore,
  hasNextPage,
  comments,
  setComments,
}: RepliesProps) {
  if (numberOfCommentsTotal <= 0) return null;

  return (
    <div>
      <Button
        className={styles.btnViewReplies}
        onClick={() => onOpenChange(!isOpen)}
        loading={loading}
      >
        <IconArrowShewron
          className={clsx(
            styles.btnViewRepliesIcon,
            isOpen && styles.btnViewRepliesIconActive
          )}
        />
        {numberOfCommentsTotal || 0}
        {numberOfCommentsTotal === 1 ? ' reply' : ' replies'}
      </Button>
      <AnimatedHeight isOpen={isOpen}>
        <CommentsList
          ownerId={ownerId}
          data={comments}
          setData={setComments}
          loading={loading}
          onLoadMore={onLoadMore}
          hasNextPage={hasNextPage}
          parentId={parentId}
          onRepplyDeleted={onRepplyDeleted}
        />
      </AnimatedHeight>
    </div>
  );
}

export default Replies;
